import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import routes from '../../Config/routes';
import './header.css';

function Header(props) {
    const [showMenu, setShowMenu] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [colorTheme, setColorTheme] = useState(localStorage.theme);
    const [logo, setLogo] = useState(colorTheme === 'dark' ? 'logo.svg' : 'logo-white.svg');
    const { pathname } = useLocation();
    const wrapperRef = useRef(null);

    const updateWidth = () => setWidth(window.innerWidth);
    
    useEffect(() => {
        
        const updateTheme = e => {
            setColorTheme(e.value);
            setLogo(e.value === 'light' || width > 767 ? 'logo.svg' : 'logo-white.svg');
        }

        document.addEventListener("onThemeChanged", updateTheme);
        return () => document.removeEventListener('onThemeChanged', updateTheme);
    }, [width])
    
    useEffect(() => {
        window.addEventListener('resize', updateWidth);
        setLogo(colorTheme === 'light' || width > 767 ? 'logo.svg' : 'logo-white.svg');
        return () => window.removeEventListener('resize', updateWidth);
    }, [colorTheme, width]);

    /**
     * Schließt das Menü nach einem Klick auf den Menüpunkt.
     * siehe auch: https://stackoverflow.com/a/70918633/20471960
     */
    useEffect(() => {
      setShowMenu(false);
    }, [pathname])
    

    /**
     * Schließt das Menü, wenn außerhalb geklickt wird.
     * https://stackoverflow.com/a/42234988/20471960
     * @param {*} ref 
     */
    const useOutsideAlerter = ref => {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowMenu(false);
                }
            }
            document.addEventListener('mousedown', handleClickOutside);

            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            }
        }, [ref]);
    }
    useOutsideAlerter(wrapperRef);

    return (
        <nav ref={wrapperRef} className='bg-white dark:bg-night-sky-blue md:bg-inherit dark:md:bg-inherit fixed md:relative z-[9999] mb-10 py-4 md:mb-0 md:py-8 mx-auto max-w-5xl px-4 flex w-full items-center flex-wrap shadow-md md:shadow-none'>
            <NavLink to='/' className='shrink-0 inline-flex md:bg-white md:rounded-full md:aspect-square md:grid md:place-items-center md:shadow-lg relative gradientBorder'>
                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo/${logo}`}
                    className='h-10 md:h-12 lg:h-20 px-4'
                    alt='Logo aida-nicl.de'
                />
            </NavLink>
            <div className='ml-auto'>
                <button
                    onClick={() => setShowMenu(!showMenu)}
                    className={`hamburger hamburger--slider inline-flex h-6 ml-auto pr-4 md:hidden scale-50 ${showMenu && 'is-active'}`}
                    type='button'
                    data-target='#navigation'
                >
                    <span className='hamburger-box'>
                        <span className='hamburger-inner'></span>
                    </span>
                </button>
            </div>
            <ul className={`${!showMenu &&'hidden'} w-full pt-4 gap-2 lg:text-xl justify-end font-heading md:flex md:flex-1 md:w-auto md:pt-0`}>
                {routes.map(route => {
                    return (
                        <li key={route.path} className='px-3 py-1 rounded-lg text-slate-500 dark:text-slate-200 hover:text-sky-900 dark:hover:text-sky-900 hover:bg-white hover:shadow'>
                            <NavLink to={route.path}>{route.label}</NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default Header;
